import { getTheme, useTheme } from "@fluentui/react";
import * as React from "react"

interface IIconProps {

}



const LoginIcon: React.FunctionComponent<IIconProps> = (props) => {

    const theme = useTheme();

    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        width={60}
        height={80}
        style={{
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            fillRule: "evenodd",
            clipRule: "evenodd",
        }}
        viewBox="0 0 198.55 196.67"
        {...props}
    >
        <path
            d="M32.12 76.6c-1.54-1.02-2.77-2.37-3.44-4.13l-2.3-6.05 5.46-3.48c1.36-.87 2.86-1.17 4.15-2.06.16-.11.31-.23.46-.35-.03-1.1-.02-2.19.01-3.28-1.06-.37-2.07-.78-3.2-1.61l-11.72-8.63 13.61-5.18c.77-.29 2.02-.7 2.7-1.18.18-.13.4-.28.61-.44.35-1.3.61-2.57 1.09-3.93C48.6 10.55 74.86 1.5 100.03 1.07c15.78-.26 31.85 3.96 44.21 14.1 13.81 11.32 18.68 25.04 17.87 42.64l-.04.88c.45.77 1.23 1.75 1.67 2.11.31.26.98.69 1.4.87l14.07 4.13L168 75.21c6.61 12.47.78 28.96-10.09 37.15-4.26 3.21-9.84 5.69-15.36 5.9-4.02 4.13-8.92 7.36-14.12 9.87-.19 1.69-.13 3.44.62 4.47.9 1.24 3.09 1.9 4.48 2.21l.25.05 47.91 13.92.37.15c3.1 1.25 6.21 3.83 8.34 6.34 5.08 5.96 7.09 13.57 7.09 21.28v19.06H1.06v-19.06c0-7.71 2.02-15.33 7.1-21.28 2.14-2.51 5.25-5.09 8.36-6.34l.37-.15 47.45-13.79c4.73-1.66 6.2-3.97 5.78-7.88-4.35-2.32-8.81-5.26-12.02-8.57-1.64 0-3.27-.24-4.9-.72-2.45-.73-4.67-1.95-6.76-3.41-1.77-1.23-4.12-3.46-5.88-4.4l-1.29-.69-.96-1.1c-7.44-8.56-10.88-21.1-6.19-31.62z"
            style={{
                fill: "none",
                stroke: "#d9d9d9",
                strokeWidth: 2.12,
                strokeMiterlimit: 22.9256,
            }}
        />
        <path
            d="m131.8 142.56 47.29 13.73s10.46 4.2 10.46 20.26v11.12H9v-11.12c0-16.06 10.49-20.26 10.49-20.26l47.27-13.73c9.93-3.41 13.18-10.46 10.35-20.82-5.08-2.39-10.45-5.71-13.44-8.86-.93-.97-1.6-1.95-2.45-2.84-7.24 2.61-12.38-4.6-16.92-7.03-5.96-6.85-8.8-17.2-3.9-25.13 1.53-2.47 2.99-3.41 5.12-4.74.68-.42.47-.17.5-1.01l-.25-1.53c-.89.02-1.49.42-2.47.52-2.22.23-6.81-.45-7.2-1.48.62-.39 2.29-.77 4.41-2.23 1.36-.94 2.46-2.08 3.37-3.37.69-.98.65-1.23.55-2.7-.23-3.4.09-8.55-.03-9.6l-1.35-.41-.5-.17c-.49-.54-3.68-1.25-4.58-1.91 1.58-.6 3.04-1.11 4.48-2.13 4.24-3.01 2.95-3.57 4.58-8.2C54.68 17.19 77.4 9.39 100.16 9.01c15.39-.25 29.08 4.12 39.05 12.3 11.58 9.5 15.68 20.61 14.97 36.14-1.27 2.74 2.29 7.64 4.49 9.46 1 .84 2.87 1.98 4.09 2.34-.59.49-1.67.66-2.44.76-.94.11-1.78.23-2.73.23-3.36-.02-5.11-2.31-5.33.76-.9 2.91.96-.22 5.74 4.06 8.18 7.33 5.52 23.14-4.87 30.96-2.91 2.2-8.9 5.37-13.92 4-4.79 6.27-11.98 10.17-17.75 12.53-3.09 11.42.69 17.85 10.34 20.01z"
            style={{
                fill: theme.palette.themePrimary,
                fillRule: "nonzero",
            }}
        />
    </svg>)
}

export default LoginIcon
